// // src/app/ar-space/PageClient.tsx
// 'use client';

// import { Suspense, useCallback, useEffect, useMemo, useState } from 'react';
// import {
//   usePathname,
//   useRouter,
//   useSearchParams,
//   type ReadonlyURLSearchParams,
// } from 'next/navigation';

// import PageContainer from '@/components/layout/PageContainer';
// import { useSetMobileHeader } from '@/components/layout/MobileHeaderProvider';
// import MobileHeader from '@/components/header/mobile-common/Header';
// import BottomNav from '@/components/bottomNav/BottomNav';

// import ArSpaceList from '@/components/page/ar-space/ArSpaceList';
// import ArSpaceFilterBar from '@/components/page/ar-space/ArSpaceFilterBar/ArSpaceFilterBar';
// //import ArSpaceFilterToggleButton from '@/components/page/ar-space/ArSpaceFilterToggleButton';

// import type { ArSpaceGroup, ArType, OrderBy } from '@/types/arSpace';
// import { ArSpaceService } from '@/libs/services/arSpace';

// type TabKind = 'all' | ArType;

// type OrderParam = 'new' | 'distance' | 'hot';
// type TypeParam = 'branch' | 'ar_space';

// const orderByText = (k: OrderBy) =>
//   k === 'crtime' ? '依最新→舊' : k === 'distance' ? '依距離近→遠' : '依熱門高→低';

// const orderByToParam = (k: OrderBy): OrderParam => {
//   if (k === 'distance') return 'distance';
//   if (k === 'article_num') return 'hot';
//   return 'new';
// };

// const orderParamToOrderBy = (v: string | null): OrderBy => {
//   if (v === 'distance') return 'distance';
//   if (v === 'hot') return 'article_num';
//   return 'crtime';
// };

// const tabToTypeParam = (tab: TabKind): TypeParam | null => {
//   if (tab === 'branch') return 'branch';
//   if (tab === 'ar_space') return 'ar_space';
//   return null;
// };

// const typeParamToTab = (v: string | null): TabKind => {
//   if (v === 'branch') return 'branch';
//   if (v === 'ar_space') return 'ar_space';
//   return 'all';
// };

// function parseFromSearchParams(sp: ReadonlyURLSearchParams): {
//   tab: TabKind;
//   orderBy: OrderBy;
//   groupId: string;
// } {
//   const tab = typeParamToTab(sp.get('type'));
//   const orderBy = orderParamToOrderBy(sp.get('order_by'));
//   const topic = sp.get('topic');
//   const groupId = topic && topic !== 'all' ? String(topic) : 'all';
//   return { tab, orderBy, groupId };
// }

// /**
//  * ✅ 把「列表狀態」寫回 URL 時，統一走這個：
//  * - type: all -> 不帶
//  * - order_by: 永遠帶（至少 new）
//  * - topic: all -> 不帶
//  */
// function applyToSearchParams(
//   curr: ReadonlyURLSearchParams,
//   next: { tab?: TabKind; orderBy?: OrderBy; groupId?: string }
// ): URLSearchParams {
//   const sp = new URLSearchParams(curr.toString());

//   // type
//   if (next.tab !== undefined) {
//     const typeVal = tabToTypeParam(next.tab);
//     if (typeVal) sp.set('type', typeVal);
//     else sp.delete('type');
//   }

//   // order_by（永遠存在）
//   if (next.orderBy !== undefined) {
//     sp.set('order_by', orderByToParam(next.orderBy));
//   } else if (!sp.has('order_by')) {
//     sp.set('order_by', 'new');
//   }

//   // topic
//   if (next.groupId !== undefined) {
//     if (next.groupId && next.groupId !== 'all') sp.set('topic', String(next.groupId));
//     else sp.delete('topic');
//   }

//   return sp;
// }

// function PageClientInner() {
//   const router = useRouter();
//   const pathname = usePathname();
//   const searchParams = useSearchParams();

//   // 1. 定義「純列表路徑」
//   const listPathname = useMemo(() => {
//     const idx = pathname.indexOf('/ar-space');
//     if (idx === -1) return '/ar-space';
//     return `${pathname.slice(0, idx)}/ar-space`;
//   }, [pathname]);

//   // ✅ 修正：嚴格判定「現在是否真的在列表頁」，而非內頁
//   // 這樣當 URL 變成 /ar-space/2498 時，isPureList 會是 false
//   const isPureList = useMemo(() => {
//     return pathname === listPathname || pathname === `${listPathname}/`;
//   }, [pathname, listPathname]);

//   // (其餘 filters, groups 邏輯保持不變...)
//   const { tab, orderBy, groupId } = useMemo(
//     () => parseFromSearchParams(searchParams),
//     [searchParams]
//   );

//   // keyword 不上 URL（保留 local state）
//   const [keyword, setKeyword] = useState('');

//   // Groups（給 FilterBar 顯示主題下拉）
//   const [groups, setGroups] = useState<ArSpaceGroup[]>([]);
//   useEffect(() => {
//     const run = async () => {
//       try {
//         const list = await ArSpaceService.getArSpaceGroup({ withAuth: false });
//         setGroups(list);
//       } catch {
//         setGroups([]);
//       }
//     };
//     void run();
//   }, []);

//   const orderByLabel = useMemo(() => orderByText(orderBy), [orderBy]);

//   // 2. 產生穩定的 URL (包含當前所有 Filter 參數)
//   const stableListUrl = useMemo(() => {
//     if (!isPureList) return null;
//     const sp = applyToSearchParams(searchParams, {});
//     const qs = sp.toString();
//     return qs ? `${listPathname}?${qs}` : listPathname;
//   }, [isPureList, listPathname, searchParams]);

//   // 3. 自動補齊缺失參數 (例如進入 /ar-space 時自動補上 order_by=new)
//   useEffect(() => {
//     if (!isPureList) return;
//     if (searchParams.has('order_by')) return;
//     if (!stableListUrl) return;

//     router.replace(stableListUrl, { scroll: false });
//   }, [isPureList, router, searchParams, stableListUrl]);

//   // 4. ✅ 關鍵修改：記住「最後一次列表 URL」
//   // 增加對 pathname 的監聽，確保進入 Modal (內頁路徑) 時停止寫入
//   useEffect(() => {
//     if (!isPureList) return;
//     if (typeof window === 'undefined') return;
//     if (!stableListUrl) return;

//     // 只有在列表頁才更新，這保證了 Modal 關閉時會回到「進入 Modal 前」的那個列表狀態
//     window.sessionStorage.setItem('arspace:lastListUrl', stableListUrl);
//   }, [isPureList, stableListUrl]);

//   const replaceUrl = useCallback(
//     (patch: { tab?: TabKind; orderBy?: OrderBy; groupId?: string }) => {
//       if (!isPureList) return;

//       const sp = applyToSearchParams(searchParams, patch);
//       const qs = sp.toString();
//       router.replace(qs ? `${listPathname}?${qs}` : listPathname, { scroll: false });
//     },
//     [isPureList, listPathname, router, searchParams]
//   );

//   // FilterBar 點 distance 時會呼叫（ArSpaceList 內部會做定位與快取）
//   const ensureUserLocation = useCallback(() => {}, []);

//   return (
//     <>
//       {/* 手機：右上角篩選按鈕 */}
//       {/* <div
//         className="d-md-none position-fixed"
//         style={{
//           zIndex: 1050,
//           top: 'var(--mobile-header-total-height, 0.7rem)',
//           right: '0.75rem',
//         }}
//       >
//         <ArSpaceFilterToggleButton />
//       </div> */}

//       <ArSpaceFilterBar
//         features={{ tabs: true, search: true, order: true, category: true }}
//         tab={tab}
//         onTab={(next) => replaceUrl({ tab: next })}
//         keyword={keyword}
//         onKeywordChange={setKeyword}
//         orderBy={orderBy}
//         orderByLabel={orderByLabel}
//         onOrder={(next) => replaceUrl({ orderBy: next })}
//         ensureUserLocation={ensureUserLocation}
//         groupId={groupId}
//         onGroup={(next) => replaceUrl({ groupId: next })}
//         arspaceGroups={groups}
//         setClass="container px-md-2"
//       />

//       <PageContainer className="pt-md-0">
//         <ArSpaceList
//           enableGroups={true}
//           filters={{ tab, keyword, orderBy, groupId }}
//           onFiltersChange={(next) => {
//             // tab / order / group → 交給 URL（只在列表路徑有效）
//             replaceUrl({ tab: next.tab, orderBy: next.orderBy, groupId: next.groupId });
//             // keyword → local
//             setKeyword(next.keyword);
//           }}
//         />

//         <BottomNav />
//       </PageContainer>
//     </>
//   );
// }

// const PageClient = () => {
//   // 手機版通用 header（放外層，避免 Suspense fallback 期間 header 沒被設定）
//   const MobileHeaderWithProps = useCallback(
//     () => <MobileHeader titleType="txt" titleTxt="AR籌碼據點" />,
//     []
//   );
//   useSetMobileHeader(MobileHeaderWithProps);

//   return (
//     <Suspense fallback={<div className="container py-4 text-center text-muted">載入中…</div>}>
//       <PageClientInner />
//     </Suspense>
//   );
// };

// export default PageClient;

// src/app/ar-space/PageClient.tsx
'use client';

import { Suspense, useCallback, useEffect, useMemo, useState } from 'react';
import {
  usePathname,
  useRouter,
  useSearchParams,
  type ReadonlyURLSearchParams,
} from 'next/navigation';

import PageContainer from '@/components/layout/PageContainer';
import { useSetMobileHeader } from '@/components/layout/MobileHeaderProvider';
import MobileHeader from '@/components/header/mobile-common/Header';
import BottomNav from '@/components/bottomNav/BottomNav';

import ArSpaceList from '@/components/page/ar-space/ArSpaceList';
import ArSpaceFilterBar from '@/components/page/ar-space/ArSpaceFilterBar/ArSpaceFilterBar';

import type { ArSpaceGroup, ArType, OrderBy } from '@/types/arSpace';
import { ArSpaceService } from '@/libs/services/arSpace';

type TabKind = 'all' | ArType;

type OrderParam = 'new' | 'newcrt' | 'distance' | 'hot';
type TypeParam = 'branch' | 'ar_space';

const orderByText = (k: OrderBy) =>
  k === 'letime'
    ? '依最新→舊'
    : k === 'crtime'
      ? '建立時間新→舊'
      : k === 'distance'
        ? '依距離近→遠'
        : '依熱門高→低';

const orderByToParam = (k: OrderBy): OrderParam => {
  if (k === 'letime') return 'new';
  if (k === 'distance') return 'distance';
  if (k === 'article_num') return 'hot';
  return 'newcrt'; // crtime
};

const orderParamToOrderBy = (v: string | null): OrderBy => {
  if (v === 'new') return 'letime';
  if (v === 'distance') return 'distance';
  if (v === 'hot') return 'article_num';
  if (v === 'newcrt') return 'crtime';

  // ✅ 預設改成 letime
  return 'letime';
};

const tabToTypeParam = (tab: TabKind): TypeParam | null => {
  if (tab === 'branch') return 'branch';
  if (tab === 'ar_space') return 'ar_space';
  return null;
};

const typeParamToTab = (v: string | null): TabKind => {
  if (v === 'branch') return 'branch';
  if (v === 'ar_space') return 'ar_space';
  return 'all';
};

function parseFromSearchParams(sp: ReadonlyURLSearchParams): {
  tab: TabKind;
  orderBy: OrderBy;
  groupId: string;
} {
  const tab = typeParamToTab(sp.get('type'));
  const orderBy = orderParamToOrderBy(sp.get('order_by'));
  const topic = sp.get('topic');
  const groupId = topic && topic !== 'all' ? String(topic) : 'all';
  return { tab, orderBy, groupId };
}

/**
 * ✅ 把「列表狀態」寫回 URL 時，統一走這個：
 * - type: all -> 不帶
 * - order_by: 永遠帶（至少 edit）
 * - topic: all -> 不帶
 */
function applyToSearchParams(
  curr: ReadonlyURLSearchParams,
  next: { tab?: TabKind; orderBy?: OrderBy; groupId?: string }
): URLSearchParams {
  const sp = new URLSearchParams(curr.toString());

  // type
  if (next.tab !== undefined) {
    const typeVal = tabToTypeParam(next.tab);
    if (typeVal) sp.set('type', typeVal);
    else sp.delete('type');
  }

  // order_by（永遠存在）
  if (next.orderBy !== undefined) {
    sp.set('order_by', orderByToParam(next.orderBy));
  } else if (!sp.has('order_by')) {
    // 預設改成 letime
    sp.set('order_by', 'new');
  }

  // topic
  if (next.groupId !== undefined) {
    if (next.groupId && next.groupId !== 'all') sp.set('topic', String(next.groupId));
    else sp.delete('topic');
  }

  return sp;
}

function PageClientInner() {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  // 1. 定義「純列表路徑」
  const listPathname = useMemo(() => {
    const idx = pathname.indexOf('/ar-space');
    if (idx === -1) return '/ar-space';
    return `${pathname.slice(0, idx)}/ar-space`;
  }, [pathname]);

  // ✅ 嚴格判定是否在列表頁（非內頁）
  const isPureList = useMemo(() => {
    return pathname === listPathname || pathname === `${listPathname}/`;
  }, [pathname, listPathname]);

  const { tab, orderBy, groupId } = useMemo(
    () => parseFromSearchParams(searchParams),
    [searchParams]
  );

  // keyword 不上 URL（保留 local state）
  const [keyword, setKeyword] = useState('');

  // Groups（給 FilterBar 顯示主題下拉）
  const [groups, setGroups] = useState<ArSpaceGroup[]>([]);
  useEffect(() => {
    const run = async () => {
      try {
        const list = await ArSpaceService.getArSpaceGroup({ withAuth: false });
        setGroups(list);
      } catch {
        setGroups([]);
      }
    };
    void run();
  }, []);

  const orderByLabel = useMemo(() => orderByText(orderBy), [orderBy]);

  // 2. 產生穩定的 URL (包含當前所有 Filter 參數)
  const stableListUrl = useMemo(() => {
    if (!isPureList) return null;
    const sp = applyToSearchParams(searchParams, {});
    const qs = sp.toString();
    return qs ? `${listPathname}?${qs}` : listPathname;
  }, [isPureList, listPathname, searchParams]);

  // 3. 自動補齊缺失參數（例如進入 /ar-space 時自動補上 order_by=edit）
  useEffect(() => {
    if (!isPureList) return;
    if (searchParams.has('order_by')) return;
    if (!stableListUrl) return;

    router.replace(stableListUrl, { scroll: false });
  }, [isPureList, router, searchParams, stableListUrl]);

  // 4. 記住「最後一次列表 URL」
  useEffect(() => {
    if (!isPureList) return;
    if (typeof window === 'undefined') return;
    if (!stableListUrl) return;

    window.sessionStorage.setItem('arspace:lastListUrl', stableListUrl);
  }, [isPureList, stableListUrl]);

  const replaceUrl = useCallback(
    (patch: { tab?: TabKind; orderBy?: OrderBy; groupId?: string }) => {
      if (!isPureList) return;

      const sp = applyToSearchParams(searchParams, patch);
      const qs = sp.toString();
      router.replace(qs ? `${listPathname}?${qs}` : listPathname, { scroll: false });
    },
    [isPureList, listPathname, router, searchParams]
  );

  // FilterBar 點 distance 時會呼叫（ArSpaceList 內部會做定位與快取）
  const ensureUserLocation = useCallback(() => {}, []);

  return (
    <>
      <ArSpaceFilterBar
        features={{ tabs: true, search: true, order: true, category: true }}
        tab={tab}
        onTab={(next) => replaceUrl({ tab: next })}
        keyword={keyword}
        onKeywordChange={setKeyword}
        orderBy={orderBy}
        orderByLabel={orderByLabel}
        onOrder={(next) => replaceUrl({ orderBy: next })}
        ensureUserLocation={ensureUserLocation}
        groupId={groupId}
        onGroup={(next) => replaceUrl({ groupId: next })}
        arspaceGroups={groups}
        setClass="container px-md-2"
      />

      <PageContainer className="pt-md-0">
        <ArSpaceList
          enableGroups={true}
          filters={{ tab, keyword, orderBy, groupId }}
          onFiltersChange={(next) => {
            replaceUrl({ tab: next.tab, orderBy: next.orderBy, groupId: next.groupId });
            setKeyword(next.keyword);
          }}
        />

        <BottomNav />
      </PageContainer>
    </>
  );
}

const PageClient = () => {
  const MobileHeaderWithProps = useCallback(
    () => <MobileHeader titleType="txt" titleTxt="AR籌碼據點" />,
    []
  );
  useSetMobileHeader(MobileHeaderWithProps);

  return (
    <Suspense fallback={<div className="container py-4 text-center text-muted">載入中…</div>}>
      <PageClientInner />
    </Suspense>
  );
};

export default PageClient;
